import { Decimal } from 'decimal.js';
import { PriceAmountType } from '../../constants/price-amount-type.js';
import { PriceDerivationOperation } from '../../constants/price-derivation-operation.js';
import { isSet } from './is-set.js';
const ALL_OR_NOTHING_MESSAGE = 'A price formula needs a basis, an operation, and a value.';
const BASIS_TERM_AND_GROUP_MESSAGE = 'A formula basis cannot target both a payment term and a payment terms group.';
const BASIS_TERM_AGNOSTIC_MESSAGE = 'Only a Wholesale basis can target a specific payment term.';
const SELF_DERIVATION_MESSAGE = 'A price formula cannot derive from the cell it sets.';
const DECREASE_PERCENT_MESSAGE = 'A percentage decrease of 100% or more would set the price to zero or below.';
// WHY: mirrors the web formula builder's rules server-side so a hand-built request can't persist an invalid formula
export function refinePriceRuleAmountDerivations(value, ctx) {
    value.amounts.forEach((row, index) => {
        const basisType = row.derivedFromAmountTypeId ?? null;
        const basisTerm = isSet(row.derivedFromPaymentTermsId) ? row.derivedFromPaymentTermsId : null;
        const basisGroup = row.derivedFromPaymentTermsGroupId ?? null;
        const operation = row.derivationOperationId ?? null;
        const derivationValue = row.derivationValue ?? null;
        const anySet = basisType !== null ||
            operation !== null ||
            derivationValue !== null ||
            basisTerm !== null ||
            basisGroup !== null;
        const allSet = basisType !== null && operation !== null && derivationValue !== null;
        if (anySet && !allSet) {
            ctx.addIssue({
                code: 'custom',
                message: ALL_OR_NOTHING_MESSAGE,
                path: ['amounts', index, 'derivationOperationId'],
            });
            return;
        }
        if (!allSet)
            return;
        if (basisTerm !== null && basisGroup !== null) {
            ctx.addIssue({
                code: 'custom',
                message: BASIS_TERM_AND_GROUP_MESSAGE,
                path: ['amounts', index, 'derivedFromPaymentTermsGroupId'],
            });
        }
        if (basisType !== PriceAmountType.WHOLESALE && (basisTerm !== null || basisGroup !== null)) {
            ctx.addIssue({
                code: 'custom',
                message: BASIS_TERM_AGNOSTIC_MESSAGE,
                path: basisTerm === null && basisGroup !== null
                    ? ['amounts', index, 'derivedFromPaymentTermsGroupId']
                    : ['amounts', index, 'derivedFromPaymentTermsId'],
            });
        }
        const ownPaymentTermsId = isSet(row.paymentTermsId) ? row.paymentTermsId : null;
        const ownPaymentTermsGroupId = row.paymentTermsGroupId ?? null;
        if (basisType === row.amountTypeId &&
            basisTerm === ownPaymentTermsId &&
            basisGroup === ownPaymentTermsGroupId) {
            ctx.addIssue({
                code: 'custom',
                message: SELF_DERIVATION_MESSAGE,
                path: ['amounts', index, 'derivedFromAmountTypeId'],
            });
        }
        // WHY: rounded to the same NUMERIC(28,9) precision the stored value ends up at (apply-price-rule-amounts.ts's derivationFieldsFor) -- a raw JS float check lets e.g. 99.9999999995 pass here but round to exactly 100 on write, silently disabling the formula forever instead of rejecting it up front.
        if (operation === PriceDerivationOperation.DECREASE_PERCENT &&
            new Decimal(derivationValue).toDecimalPlaces(9).gte(100)) {
            ctx.addIssue({
                code: 'custom',
                message: DECREASE_PERCENT_MESSAGE,
                path: ['amounts', index, 'derivationValue'],
            });
        }
    });
}
//# sourceMappingURL=derivation-refine.js.map